import React from "react";
import PageTransition from "../PageTransition";
import { AnimatedBackground } from 'animated-backgrounds';

import Banner from "./components/banner/Banner";
import AboutMe from "./components/about/AboutMe";
import Projects from "./components/projects/Projects";
import Experience from "./components/experience/Experience";
import Contact from "./components/contact/Contact";
import "./Home.css";

export default function Home() {
    return (
        <PageTransition>
            <div className="home-container">

                <AnimatedBackground 
                    animationName="fireflies" 
                    blendMode="difference"
                />

                <Banner/>

                <div id="about">
                    <AboutMe/>
                </div>

                <div id="projects">
                    <Projects/>
                </div>

                <div id="experience">
                    <Experience/>
                </div>
                
                <Contact/>

            </div>
        </PageTransition>
    );
}